import { useHeroBanner } from "./context/HeroBannerContext"
import { HeroBanner } from "./HeroBanner"

export const HeroBannerContainer = () => {
  const { activeBanner, dismiss } = useHeroBanner()

  if (!activeBanner) return null

  return (
    <HeroBanner
      banner={activeBanner}
      onClose={() => dismiss(activeBanner.uid)}
    />
  )
}
